// extracted by mini-css-extract-plugin
module.exports = {"pagemaintitle":"tnpsc-demo-class-video_pagemaintitle__JJIRX","sectiontitle":"tnpsc-demo-class-video_sectiontitle__oPwPh","tablinks":"tnpsc-demo-class-video_tablinks__cKVI2"};